import { useEffect, useState } from "react";

export default function FooterComponent() {

    const [getYear, setGetYear] = useState("");

    const GetYear = () => {
        const d = new Date();
        let year = d.getFullYear();
        setGetYear(year)
    }

    useEffect(() => {
        GetYear();
    }, [])

    return (
    <div className="">
        <div className="bg-footer p-6">
            <div className="flex justify-center items-center flex-col gap-5">
                <div className="">
                    <img src="https://res.cloudinary.com/datadriven/image/upload/v1624261329/Wordpress%20Alcott/Alcott_Logo_-2.png" alt="" className="w-[200px] h-[auto]" />
                </div>
                <div className="text-white flex flex-col justify-center items-center gap-3">
                    <div className="">
                        <span>Copyright &copy; {getYear}</span>
                    </div>
                    <div className="">
                        <span>Alcott Semarang is part of Alcott Group UK</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}